import { jsxs, jsx } from 'react/jsx-runtime';
import './PaymentTabsWrapper.module.scss.js';
import classNames from 'classnames';
import PaymentTab from '../PaymentTab/PaymentTab.js';
import { MOBILE_BREAKPOINT_UPTO_3_PM, MOBILE_BREAKPOINT_4_PM, MOBILE_BREAKPOINT_MORETHAN_4_PM, DESKTOP_BREAKPOINT_UPTO_5_PM, DESKTOP_BREAKPOINT_6_PM, DESKTOP_BREAKPOINT_MORETHAN_6_PM, DESKTOP_BREAKPOINT_MORETHAN_8_PM } from '../../../config/consts.js';
import useIsMobile from '../../../hooks/useIsMobile.js';
import { usePaymentContext } from '../../../providers/PaymentContextProvider.js';
import { bancontactPaymentMethods } from '../../../types-internal/ModernizePaymentTypes.js';
import { getBancontactPaymentMethodStatus, getPaymentMethodStatus, onPaymentMethodClick } from '../../../utils/modernizePaymentUtils.js';

/**
 * **[design (Figma)](https://www.figma.com/file/jUxPlQxNticb2udxWuJq2C/Modernize-Checkout-Pages?type=design&node-id=3288-421427&mode=dev)**
 *
 * @param {string | array} paymentMethods - (from {@link PaymentMethod}) An item or array of objects containing a type: PaymentMethods and status: PaymentMethodStatus to be rendered in an predefined grid arrangement. Check design [here](https://www.figma.com/file/jUxPlQxNticb2udxWuJq2C/Modernize-Checkout-Pages?type=design&node-id=3288-421427&mode=dev).
 */
const PaymentTabsWrapper = ({ paymentMethods, issuers, children, className, }) => {
    const isMobile = useIsMobile();
    const { selectedPayment, setSelectedPayment, checkoutState } = usePaymentContext();
    const { customerType } = checkoutState || {};
    const paymentMethodsLength = paymentMethods?.length || 0;
    const issuerLength = issuers?.banks?.length || 0;
    return (jsxs("div", { "data-zta": "paymentTabsWrapper", className: classNames('paymentTabsWrapper', className, {
            [MOBILE_BREAKPOINT_UPTO_3_PM]: isMobile && (paymentMethodsLength <= 3 || issuerLength <= 3),
        }, {
            [MOBILE_BREAKPOINT_4_PM]: isMobile && (paymentMethodsLength === 4 || issuerLength === 4),
        }, {
            [MOBILE_BREAKPOINT_MORETHAN_4_PM]: isMobile && (paymentMethodsLength >= 5 || issuerLength >= 5),
        }, {
            [DESKTOP_BREAKPOINT_UPTO_5_PM]: !isMobile && (paymentMethodsLength <= 5 || issuerLength <= 5 || issuerLength > 8),
        }, {
            [DESKTOP_BREAKPOINT_6_PM]: !isMobile && (paymentMethodsLength === 6 || issuerLength == 6),
        }, {
            [DESKTOP_BREAKPOINT_MORETHAN_6_PM]: !isMobile && (paymentMethodsLength >= 7 || (issuerLength >= 7 && issuerLength <= 8)),
        }, {
            [DESKTOP_BREAKPOINT_MORETHAN_8_PM]: !isMobile && issuerLength > 8,
        }), children: [paymentMethods?.map((payment) => {
                if (payment.paymentMethodShortName) {
                    if (payment.paymentMethodShortName === 'BM' &&
                        paymentMethods.find((pm) => pm.paymentMethodShortName === 'BC')) {
                        return null;
                    }
                    return (jsx(PaymentTab, { paymentMethod: payment.paymentMethodShortName, variant: bancontactPaymentMethods.includes(payment.paymentMethodShortName || '')
                            ? getBancontactPaymentMethodStatus(paymentMethods, selectedPayment, customerType)
                            : getPaymentMethodStatus(payment, selectedPayment, customerType), onClick: onPaymentMethodClick(paymentMethods, payment, selectedPayment, customerType, setSelectedPayment) }, payment.paymentMethod));
                }
                return null;
            }), issuers?.banks?.map((issuer) => selectedPayment?.paymentMethodShortName && (jsx(PaymentTab, { className: "issuer", url: issuer.logoUrl || '', paymentMethod: issuers.method, variant: issuer.issuerId === issuers.selectedIssuer?.issuerId ? 'selected' : 'default', onClick: () => {
                    setSelectedPayment({
                        ...selectedPayment,
                        details: { lastIssuer: issuer, issuers: issuers.banks },
                    });
                } }, issuer.issuerId))), children] }));
};

export { PaymentTabsWrapper as default };
//# sourceMappingURL=PaymentTabsWrapper.js.map
